// import React from 'react';
// import ReactDOM from 'react-dom';
// import 'animate.css';
// import App from './App';

// // replace console.* for disable log on production
// if (process.env.NODE_ENV === 'production') {
 
//   console.error = () => {}
//   console.debug = () => {}
// }

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
import React from 'react';
import 'animate.css';
import App from './App';
import { createRoot } from 'react-dom/client';

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
 
   console.error = () => {}
   console.debug = () => {}
 }

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
   <App />
);